module.exports = __webpack_public_path__ + "static/media/spike_planted.0a98db47.svg";